// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Popover__popover-d32e8c {
  background-color: var(--base-10);
  z-index: 1;
  padding: 8px 0;
  border: 1px solid var(--base-30);
  box-sizing: border-box;
  box-shadow: var(--box-shadow-popover);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
}

.Popover__popover--dark-ce5c3a {
  background-color: var(--addition-100);
  border: none;
}`, "",{"version":3,"sources":["webpack://./../../packages/ui-kit/src/Popover/Popover.styles.m.css"],"names":[],"mappings":"AAAA;EACE,gCAAA;EACA,UAAA;EACA,cAAA;EAEA,gCAAA;EACA,sBAAA;EACA,qCAAA;EACA,kBAAA;EAEA,aAAA;EACA,sBAAA;AADF;;AAIA;EACE,qCAAA;EACA,YAAA;AADF","sourcesContent":[".popover {\n  background-color: var(--base-10);\n  z-index: 1;\n  padding: 8px 0;\n\n  border: 1px solid var(--base-30);\n  box-sizing: border-box;\n  box-shadow: var(--box-shadow-popover);\n  border-radius: 8px;\n\n  display: flex;\n  flex-direction: column;\n}\n\n.popover--dark {\n  background-color: var(--addition-100);\n  border: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"popover": `Popover__popover-d32e8c`,
	"popover--dark": `Popover__popover--dark-ce5c3a`,
	"popoverDark": `Popover__popover--dark-ce5c3a`
};
module.exports = ___CSS_LOADER_EXPORT___;
